import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=6d00525a&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&id=6d00525a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00525a",
  null
  
)

export default component.exports